import React, { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Progress as Bar } from './ui/progress';
import { Gift, Trophy, Sparkles } from 'lucide-react';
import { giftsAPI, mediaUrl } from '../services/api';

export const NextGiftCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    giftsAPI.list().then(setData).catch(() => {});
  }, []);

  if (!data || !data.gifts || data.gifts.length === 0) return null;

  const { in_top10, rank, total_members, gap_to_top10, next_gift, points } = data;
  const outOfTop10 = total_members >= 10 && !in_top10;

  // Out of Top 10: show next gift photo + points to enter Top 10
  if (outOfTop10) {
    return (
      <Card data-testid="next-gift-card" className="p-5 rounded-2xl bfc-gradient-warm text-white border-0">
        <div className="flex items-center gap-2 mb-3">
          <Gift className="w-5 h-5" />
          <span className="text-sm font-semibold uppercase tracking-wide">Prochain cadeau à viser</span>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-16 h-16 rounded-xl overflow-hidden bg-white/15 flex items-center justify-center shrink-0">
            {next_gift?.photo_url ? (
              <img src={mediaUrl(next_gift.photo_url)} alt={next_gift.name} className="w-full h-full object-cover" />
            ) : (
              <Trophy className="w-7 h-7 text-white" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            {next_gift && <p className="font-bold leading-tight">{next_gift.name}</p>}
            <p className="text-sm mt-1 opacity-95">
              Tu es <span className="font-extrabold">{rank}<sup>e</sup></span> — il te manque{' '}
              <span className="font-extrabold" data-testid="gap-top10">{gap_to_top10} points</span> pour entrer dans le Top 10 et débloquer les cadeaux 🎁
            </p>
          </div>
        </div>
      </Card>
    );
  }

  if (!next_gift) {
    return (
      <Card data-testid="next-gift-card" className="p-5 rounded-2xl bfc-gradient-warm text-white border-0">
        <div className="flex items-center gap-2"><Sparkles className="w-5 h-5" /><span className="font-semibold">Tu as atteint tous les paliers de cadeaux 🎉</span></div>
      </Card>
    );
  }

  const required = next_gift.required_points || 0;
  const pct = required ? Math.min(100, Math.round((points / required) * 100)) : 100;

  return (
    <Card data-testid="next-gift-card" className="p-5 rounded-2xl bfc-gradient-warm text-white border-0">
      <div className="flex items-center gap-2 mb-3">
        <Gift className="w-5 h-5" />
        <span className="text-sm font-semibold uppercase tracking-wide">Mon prochain cadeau</span>
      </div>
      <div className="flex items-center gap-3">
        <div className="w-16 h-16 rounded-xl overflow-hidden bg-white/15 flex items-center justify-center shrink-0">
          {next_gift.photo_url ? (
            <img src={mediaUrl(next_gift.photo_url)} alt={next_gift.name} className="w-full h-full object-cover" />
          ) : (
            <Gift className="w-7 h-7 text-white" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold leading-tight">{next_gift.name}</p>
          {next_gift.reached ? (
            <p className="text-sm mt-1 font-semibold" data-testid="gift-reached-message">🎉 Félicitations, tu as atteint le palier de ce cadeau ! Le coach validera ton attribution.</p>
          ) : (
            <p className="text-sm mt-1 opacity-95" data-testid="gift-missing-message">Il te manque <span className="font-extrabold">{next_gift.missing_points} points</span> pour gagner ton prochain cadeau</p>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between mt-3 mb-1 text-xs">
        <span className="opacity-90">{points} pts</span>
        <span className="font-bold">{points}/{required}</span>
      </div>
      <Bar value={pct} className="h-2 bg-white/25" indicatorClassName="bg-white" />
    </Card>
  );
};
